import { useRouter } from 'next/router'
import useTranslation from 'next-translate/useTranslation'
import { useIsFetching } from 'react-query'

import Button from '@/atoms/Button/Button'
import { hideModals } from '@/store/slices/modal'

function BottomBar({ count = 0 }) {
  const { t } = useTranslation('products')
  const isFetchingProducts = useIsFetching() > 0
  const router = useRouter()

  const isCreatorsPage = router.pathname.includes('creators')
  const tKey = isCreatorsPage ? 'display_creators' : 'display_products'

  const text = t(tKey, { count })

  return (
    <div
      className="fixed bottom-0 flex justify-center w-full py-4 bg-white xl:hidden"
      style={{ boxShadow: '0px -3px 15px rgba(0,0,0,0.15)' }}
    >
      <Button
        className="w-full h-12 px-3 text-sm max-w-280px"
        text={text}
        isLoading={isFetchingProducts}
        onClick={() => hideModals()}
      />
    </div>
  )
}

export default BottomBar
